import React from 'react';
import './sec1.css'
import pic4 from '../assets/pic4.png'
import '@google/model-viewer';
import pic5 from '../assets/pic5.png'
import pic6 from '../assets/pic6.png'
import pic7 from '../assets/pic7.png'
import pic8 from '../assets/pic8.png'
import pic9 from '../assets/pic9.png'
import { useEffect } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useRef } from 'react';

const Sec1 = ({ loading }) => {
const [headers, setheaders]= useState([]);

  const secRef = useRef(null);


useEffect(() => {
  if (loading) return;

  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0.3 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, [loading]);







useEffect(() => {
const getheaders = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;
console.log(res.data);
console.log(res.data[0]?.title_ar);
setheaders(res.data);
}
getheaders();
}, []);




    return (  
        <section className='sec1-container' ref={secRef}>
                <article className='sec1-sub-container'>
                    <h1 className='header-hero'>{headers?.[0]?.header}</h1>
                    <img className='img-hero' src={pic4} alt='hero-section-decorative-img'></img>
                </article>

{/* <figure className='figure-container-modelss'>
                <figure className='model-container'>
                <model-viewer 
                className='model1'
                src="/models/cc0_-_lamp_2.glb"
                  camera-controls tone-mapping="neutral" 
                            ar
                            ar-modes="scene-viewer quick-look"      
                                     poster="poster.webp"
                                     field-of-view="12deg"
                                                  shadow-intensity="1"
                >
                    <div class="progress-bar hide" slot="progress-bar">
                        <div class="update-bar"></div>
                    </div>
                    <button slot="ar-button" id="ar-button">
                        View in your space
                    </button>
                </model-viewer>

                </figure>

</figure> */}
<figure className='container-imgs-hero'>
                <img className='img-right-hero' src={pic5} alt='lamp-image'></img>
                 <img className='img-left-hero' src={pic6} alt='lamp-image'></img>    
                 <img className='img-right-hero2' src={pic7} alt='lamp-image'></img>    
                 <img className='img-right-hero3' src={pic8} alt='lamp-image'></img>    
                 <img className='img-left-hero3' src={pic9} alt='lamp-image'></img>   
</figure>

        </section>
    );
}
 
export default Sec1